const BaseComponent = require('base/base-component');

class Card extends BaseComponent {
  init () {
    const notice=this.$el.find('#major-notice');
    const rule=this.$el.find('#new-rule');
    notice.click(this.majorShow);
    rule.click(this.ruleShow);
    this.majorShow();
  }
  majorShow() {
    $('#major-notice').addClass('active');
    $('#new-rule').removeClass('active');
    $('.sh-home-major-notice .card__body .list:first-child ').addClass('active');
    $('.sh-home-major-notice .card__body .list:last-child ').removeClass('active');
    $('.sh-major-rule-more').attr('href','/shCategory12/shCategory102/index.html');
  }
  ruleShow () {
    $('#major-notice').removeClass('active');
    $('#new-rule').addClass('active');
    $('.sh-home-major-notice .card__body .list:first-child ').removeClass('active');
    $('.sh-home-major-notice .card__body .list:last-child ').addClass('active');
    $('.sh-major-rule-more').attr('href','/shCategory13/index.html');
  }
}
module.exports = Card;
